import { makeStyles } from '@material-ui/styles'
// Constant
import Colors from '../../constants/Colors'

export default makeStyles(theme => ({
  regularStoreScheduleTableRoot: {
    marginTop: '24px',
  },
  description: {
    marginBottom: '24px',
    fontSize: '13px',
    color: Colors.PRIMARY_FONT_COLOR,
    letterSpacing: 0,
  },
  customBlocksContainer: {
    [theme.breakpoints.up('md')]: {
      padding: '0px 24px',
    },
  },
}))
